<template>
  <mds-alert
    :persistent="true"
    tinted
    class="feed-manager__alert"
    variation="warning"
  >
    {{ description }}
    <mds-button
      v-show="!attestationMessage"
      slot="mds-alert-custom-action"
      target="_blank"
      :href="DATA_DISTRIBUTION_URL"
      :text="translate('limitedAccess.button')"
    />
  </mds-alert>
</template>

<script>
import MdsAlert from '@mds/alert'
import { MdsButton } from '@mds/button'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/limitedDistribution/config/i18n'
import { DATA_DISTRIBUTION_URL } from '@/components/limitedDistribution/config/constants'

export default {
  name: 'LimitedAccessAlert',
  components: {
    MdsAlert,
    MdsButton,
  },
  props: {
    rows: {
      type: Number,
      default: 25,
    },
    attestationMessage: Boolean,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      DATA_DISTRIBUTION_URL,
    }
  },
  computed: {
    description() {
      if (this.attestationMessage) {
        return this.translate('limitedAccess.alert.attestation.description')
      }
      const alertDescription = this.translate('limitedAccess.alert.description')
      return alertDescription.replace(/#/g, this.rows)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.feed-manager__alert {
  position: absolute;
  left: 0;
  top: 0;
  animation: fadeIn 0.5s ease-in-out 0s forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
